import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AutoRouter } from './components/AutoRouter';
import { ProtectedRoute } from './components/ProtectedRoute';
import AdminLayout from './components/layout/AdminLayout';
import Dashboard from './pages/Dashboard';
import Workflows from './pages/Workflows';
import FormsManager from './pages/FormsManager';
import FormBuilderPage from './pages/FormBuilderPage';
import Users from './pages/Users';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import UserFormPage from './pages/UserFormPage';
import RoleFormPage from './pages/RoleFormPage';
import { Auth } from './pages/Auth';
import Blockchains from './pages/Blockchains';
import Contracts from './pages/Contracts';
import Methodologies from './pages/Methodologies';
import Tokens from './pages/Tokens';
import Roles from './pages/Roles';
import Reports from './pages/Reports';
import ReportDetail from './pages/ReportDetail';
import Requests from './pages/Requests';

function App() {

  return (
    <Router>
      <AutoRouter>
        <div className="min-h-screen bg-background">
          <Routes>
            <Route path="/auth/*" element={<Auth />} />
            
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Dashboard />} />
            </Route>

            <Route path="/workflows" element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Workflows />} />
            </Route>

            <Route path="/forms" element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<FormsManager />} />
            </Route>

            <Route path="/reports" element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Reports />} />
            </Route>

            <Route path="/reports/:id" element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<ReportDetail />} />
            </Route>

            <Route path="/users" element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Users />} />
            </Route>

            <Route path="/roles" element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Roles />} />
            </Route>

            <Route path="/requests" element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Requests />} />
            </Route>
            
            <Route path="/analytics" element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Analytics />} />
            </Route>
            
            <Route path="/settings" element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Settings />} />
            </Route>
            
            <Route path="/forms/new" element={
              <ProtectedRoute>
                <FormBuilderPage />
              </ProtectedRoute>
            } />
            <Route path="/forms/edit/:formId" element={
              <ProtectedRoute>
                <FormBuilderPage />
              </ProtectedRoute>
            } />
            <Route path="/users/new" element={
              <ProtectedRoute>
                <UserFormPage />
              </ProtectedRoute>
            } />
            <Route path="/users/edit/:userId" element={
              <ProtectedRoute>
                <UserFormPage />
              </ProtectedRoute>
            } />
            <Route path="/roles/new" element={
              <ProtectedRoute>
                <RoleFormPage />
              </ProtectedRoute>
            } />
            <Route path="/roles/edit/:roleId" element={
              <ProtectedRoute>
                <RoleFormPage />
              </ProtectedRoute>
            } />

            {/* Resource Management Routes */}
            <Route path="/blockchains" element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Blockchains />} />
            </Route>

            <Route path="/contracts" element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Contracts />} />
            </Route>

            <Route path="/methodologies" element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Methodologies />} />
            </Route>

            <Route path="/tokens" element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Tokens />} />
            </Route>
          </Routes>
          <Toaster position="top-right" />
        </div>
      </AutoRouter>
    </Router>
  );
}

export default App;
